<template lang="html">
  <div id="service-page">

    <section class="main-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-banner">
            <div class="image">
              <div class="placed-backg img-fake" v-bind:style="{ backgroundImage: 'url(public/images/pages/services/banner-2.jpg)' }"></div>
              <img src="public/images/pages/services/banner-services.jpg">
            </div>
          </div>

          <div class="col-lg-12 col-content">
            <h5 class="title">Nuestros Servicios</h5>
            
            <h6 class="subtitle">De la Idea al Producto Final: Su Socio Experto en Inyección de Plástico</h6>

            <p>
              En Procesos Plásticos Inyectados S.A. de C.V., transformamos sus ideas en
              realidades tangibles. Con una experiencia acumulada de más de 25 años en el
              campo de la inyección de termoplásticos, nos hemos consolidado como un
              socio confiable y experto para el desarrollo de productos, sirviendo desde el
              mercado de consumo masivo hasta industrias altamente especializadas,
              como la automotriz.
            </p>

            <h6 class="mt-3 subtitle">Un Servicio Integral: De la Conceptualización a la Producción</h6>
            <p>
              Entendemos que el camino para lanzar un nuevo producto puede ser
              complejo. Por eso, nuestro principal objetivo es simplificarlo para usted.
              Ofrecemos un servicio integral que abarca todo el ciclo de vida del proyecto,
              asegurando un resultado exitoso con un único punto de contacto
            </p>

            <br />
            <p>
              Nuestro proceso funciona de la siguiente manera:
            </p>
            <ol>
              <li>
                Desarrollo del Concepto: Usted trae la idea y nosotros le brindamos un
                servicio de excelencia en el desarrollo del nuevo producto.
              </li>
              <li>
                Creación de Prototipos: Antes de invertir en costosos moldes, ofrecemos
                la fabricación de prototipos rápidos. Esta fase es crucial para poner a
                prueba sus diseños, validar la funcionalidad y hacer ajustes, ahorrando
                tiempo y dinero.
              </li>
              <li>
                Gestión y Fabricación de Moldes: Trabajamos de la mano con una red de
                empresas aliadas, 100% mexicanas y expertas en la elaboración de
                moldes de inyección de alta precisión, utilizando tecnología CNC de
                vanguardia. Gestionamos todo el proceso hasta que el molde está listo y
                optimizado.
              </li>
              <li>
                Inyección y Producción: Una vez aprobado el molde, llevamos a cabo la
                producción en serie en nuestras propias instalaciones, garantizando la
                calidad y consistencia en cada pieza.
              </li>
            </ol>

            <br />
            <h6 class="subtitle">Nuestras Capacidades a su Servicio</h6>
            <p>
              Nuestra infraestructura tecnológica nos permite adaptarnos a las necesidades
              específicas de su proyecto, sin importar su escala o complejidad.
            </p>
            <ul>
              <li>
                Capacidad de Inyección Flexible: Manejamos proyectos con piezas desde
                los 45 gramos hasta 1.5 kg.
              </li>
              <li>
                Maquinaria Versátil: Contamos con una capacidad de inyección que va
                desde las 150 hasta las 305 toneladas de fuerza de cierre.
              </li>
            </ul>

            <br />
            <p>
              Gracias a esta flexibilidad, podemos producir una inmensa variedad de
              productos plásticos con la más alta calidad.<br />
              Permítanos ser el socio estratégico que impulse su próximo proyecto. Nuestra
              experiencia, tecnología y modelo de servicio integral están a su disposición
              para convertir sus diseños en productos exitosos. Contáctenos para
              comenzar.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Brands -->
    <section class="container mb-3 brands-section">
      <div class="row">
        <div class="col-12 col-sm-title">
          <h2 class="title-s1">Nuestros clientes</h2>
        </div>

        <div class="col-12 col-brands">
          <swiper class="swiper" :options="brandsOptions">
            <swiper-slide v-for="(brand, brhInx) in brands" :key="'brhInx-'+brhInx">
              <div class="box-brand">
                <!-- <router-link to=""> -->
                <a :href="brand.link">
                  <div class="inside">
                    <img :src="brand.imageUrl">
                  </div>
                </a>
                <!-- </router-link> -->
              </div>
            </swiper-slide>

            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </section>
    <!--  -->

    <!-- Blog -->
    <section class="blog-section">
      <div class="container med-container">
        <div class="row">
          <div class="col-12 col-title">
            <h2 class="title-s1">Acerca de la inyección de plásticos</h2>
          </div>

          <div class="col-12">
            <swiper class="swiper swiper-st-2" :options="blogOptions">
              <swiper-slide v-for="(ah, ahInx) in blog" :key="'ahInx-'+ahInx">
                <div class="col-12 px-0 box-article-s1">
                  <router-link class="box" target="_blank" :to="ah.link">
                    <div class="placed-backg box-image" v-bind:style="{ backgroundImage: 'url('+ah.image+')' }"></div>

                    <div class="box-info">
                      <h5 class="text-center title">{{ ah.name }}</h5>

                      <div class="b-text" v-html="ah.short_description"></div>
                    </div>
                  </router-link>
                </div>
              </swiper-slide>

              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      </div>
    </section>
    <!--  -->

  </div>
</template>

<script>
export default {
  data() {
    return {
      blog: [
        { image: 'public/images/pages/services/inyeccion-2.jpg',
          link: 'servicios/que-es-la-inyeccion-de-plasticos',
          name: '¿Que es la inyección de plásticos?',
          short_description: `
            <p>En ingeniería, el moldeo por inyección es un proceso semicontinuo que consiste en inyectar un polímero en estado fundido (o ahulado) en un molde cerrado a presión y frío, a través de un orificio pequeño llamado compuerta.<br /><br /> En ese molde el material se solidifica, comenzando a cristalizar en polímeros semicristalinos. La pieza o parte final se obtiene al abrir el molde y sacar de la cavidad la pieza moldeada. </p>
          `
        },
        { image: 'public/images/pages/services/molde-1.jpg',
          link: 'servicios/que-es-un-molde-de-inyeccion',
          name: '¿Que es un molde de inyeccion?',
          short_description: `
            <p>En el moldeo por inyección para la elaboración de altos volúmenes de producción con una excelente calidad, es indispensable un molde de buenas cualidades, con una elaboración muy precisa, y duración aceptable. Los dos pasos más importantes en la producción de una pieza plástica son el diseño de la pieza y el diseño del molde.<br />El tipo de molde a elegir, para una pieza viene determinado esencialmente por consideraciones sobre el diseño del mismo.</p>  
          `
        },
      ],

      brands: [
        { link: null, imageUrl: 'public/images/pages/services/brand-1.jpg' },
        { link: null, imageUrl: 'public/images/pages/services/brand-2.jpg' },
        { link: null, imageUrl: 'public/images/pages/services/brand-3.jpg' },
        { link: null, imageUrl: 'public/images/pages/services/brand-4.jpg' },
        { link: null, imageUrl: 'public/images/pages/services/brand-5.jpg' },
      ],

      // == Carousels ==
      blogOptions: {
        slidesPerView: 2,
        spaceBetween: 30,

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        breakpoints: {
          992: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
        }
      },

      brandsOptions: {
        loop: true,
        slidesPerView: 3,
        spaceBetween: 20,

        autoplay: {
          delay: 4500,
          disableOnInteraction: false
        },

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          992: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 2,
          },
          0: {
            slidesPerView: 2,
          },
        }
      },
      // == ==
    }
  },

  methods: {
    getBlog() {
      this.isLoading = true;
      axios.get(tools.url('/api/blog')).then((response) =>{
        this.blog = response.data;
        this.isLoading = false;
      }).catch((error)=>{
        console.log(error);
      });
    },
  },

  beforeMount() {
    // this.getBlog();
  }
}
</script>
